module.exports = __webpack_public_path__ + "img/import.caaf12d6.svg";